export default __webpack_public_path__ + "static/media/dropzoneimage.495eefed.png";